import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  cancelAndRefundOrderMockEligibleToRefund,
  getOrderEligibilitiesMockEligibleToRefundOnPaypalAndOnlineBanking,
  orderEligibilitiesMockNotEligibleToRefund,
  orderMockEligibleToRefund,
  orderMockNotEligibleToRefund,
} from '../../../mock/data/index';
import {
  noActiveItineraryWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries/index';

/**
 * Mocks for refundable order.
 */
export const eligibleToRefundOnPaypalAndOnlineBankingMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefund), createMockData(orderMockNotEligibleToRefund, [], [noActiveItineraryWarning])],
  getOrderEligibilities: [
    {
      mockData: getOrderEligibilitiesMockEligibleToRefundOnPaypalAndOnlineBanking
    },
    createMockData(orderEligibilitiesMockNotEligibleToRefund, [], [orderNotEligibleForRefundWarning])
  ],
  cancelAndRefundOrder: [
    {
      mockData: cancelAndRefundOrderMockEligibleToRefund,
      getResponse: () => {
        return new Response(JSON.stringify(cancelAndRefundOrderMockEligibleToRefund), {
          status: 201
        });
      }
    },
    createMockDataWithResponse(orderEligibilitiesMockNotEligibleToRefund, 201)
  ]
};
